import { render, staticRenderFns } from "./InputWithVKeyboard.vue?vue&type=template&id=3b2050b6&scoped=true&"
import script from "./InputWithVKeyboard.vue?vue&type=script&lang=js&"
export * from "./InputWithVKeyboard.vue?vue&type=script&lang=js&"
import style0 from "./InputWithVKeyboard.vue?vue&type=style&index=0&id=3b2050b6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2050b6",
  null
  
)

export default component.exports